import { TradeSide } from '@ovComponents/5-page/portfolioTradingHub/types';
import { groupTotalsByCurrency } from '@ovComponents/5-page/portfolioTradingHub/utils/reviewRebalanceCalculations';
import { useMemo } from 'react';
import type { StagedTrade } from './types';

export const useTradeStatsByCurrency = (activeTrades: StagedTrade[]) =>
  useMemo(() => {
    const portfolioIds = new Set(activeTrades.map((t) => t.portfolioReportId));
    const { buys, sells } = activeTrades.reduce(
      (counts, trade) => {
        if (trade.side === TradeSide.BUY) {
          counts.buys++;
        } else {
          counts.sells++;
        }
        return counts;
      },
      { buys: 0, sells: 0 },
    );

    return {
      portfolioCount: portfolioIds.size,
      totalTrades: activeTrades.length,
      buyCount: buys,
      sellCount: sells,
      totalsByCurrency: groupTotalsByCurrency(
        activeTrades.map((t) => ({
          currency: t.currency,
          side: t.side,
          amountCents: t.amountCents,
        })),
      ),
    };
  }, [activeTrades]);
